import styles from "./AntennaHubScreen.module.scss";

export interface SeenCtrBarProps {
  seenCount: number | null | undefined;
  clickCount: number | null | undefined;
}

/**
 * The per-announcement seen/CTR bar (shot-37): a big CTR%, a "N seen" sub-line, and a bar whose width IS the CTR
 * (dedupe guarantees CTR ≤ 100%). Sourced from the Antenna band-metrics API via the announcements list
 * (A4). When the count is null — a draft, or Antenna unavailable — this DEGRADES to a plain em-dash and
 * fabricates NOTHING (F-06 honesty; the hub never invents an engagement number).
 */
export function SeenCtrBar({ seenCount, clickCount }: SeenCtrBarProps) {
  if (seenCount == null) {
    return (
      <span className={styles.stats} aria-label="Engagement stats arrive after launch">
        —
      </span>
    );
  }

  const clicks = clickCount ?? 0;
  const ctr = seenCount > 0 ? Math.min(100, Math.round((clicks / seenCount) * 100)) : 0;

  return (
    <span className={styles.stats} aria-label={`${ctr}% click-through, ${seenCount} seen`}>
      <span className={styles.ctr}>{ctr}% CTR</span>
      <span className={styles.seen}>{seenCount} seen</span>
      <span className={styles.ctrBar} aria-hidden="true">
        <span className={styles.ctrFill} style={{ width: `${ctr}%` }} />
      </span>
    </span>
  );
}
